import { useEffect, useState } from "react";
import { useToggle } from "react-use";
import { socketPromise } from "./socketPromise";
export function useHermes(type) {
    const [connected, toggleConnected] = useToggle(false);
    const [gotFirstMessage, toggleGotFirstMessage] = useToggle(false);
    const [message, setMessage] = useState(null);
    const [socket, setSocket] = useState(null);
    useEffect(()=>{
        (async ()=>{
            try {
                const socketLocal = await socketPromise();
                setSocket(socketLocal);
            } catch (error) {
                console.error('Error resolving socket:', error);
            }
        })();
    }, [
        type
    ]);
    useEffect(()=>{
        if (socket) {
            socket.connect();
            socket.on(type, (msg)=>{
                setMessage(()=>msg);
                toggleGotFirstMessage(true);
            });
            socket.on('connect', ()=>{
                toggleConnected(true);
            });
            socket.on('disconnect', ()=>{
                toggleConnected(false);
            });
            return ()=>{
                socket.off(type);
                socket.disconnect();
            };
        }
    }, [
        socket
    ]);
    /**
   * ensure connection was made and
   */ return [
        message,
        {
            connected: connected && gotFirstMessage
        }
    ];
}

//# sourceMappingURL=useHermes.js.map